
import Button from '@mui/material/Button';

function ScheduleDemoButton({ onClick }) {
  return (
    <Button
      disableElevation
      variant="contained"
      sx={(theme) => ({
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.78rem',
        borderRadius: '999px',
        px: 2,
        py: 0.75,
        whiteSpace: 'nowrap',
        lineHeight: 1.4,
        backgroundColor: theme.palette.primary.main,
        transition: 'all 0.25s ease',
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
          transform: 'scale(1.05)',
          boxShadow: theme.shadows[4],
        },
      })}
      onClick={onClick}
    >
      Schedule a Demo
    </Button>
  );
}

export default ScheduleDemoButton;
